module.exports = __webpack_public_path__ + "static/media/nova-logo-mini.423eb62e.svg";